export const templateReplacer = (string: string, variables: Record<string, string | number>) => {
  return Object.keys(variables).reduce(
    (acc, key) => acc.replace(`%{${key}}`, String(variables[key])),
    string,
  );
};
